@if (content(); as content) {
  @if (items(); as items) {
    <div
      class="mr-xlarge-b"
      [class.pr-small-t]="!subjectTaxonomyTags().includes(TAXONOMY.NO_PADDING)"
      [class.section-marker]="!subjectTaxonomyTags().includes(TAXONOMY.NO_SECTION_MARKER)"
    >
      @if (title(); as title) {
        <h2 class="mr-clear-t" [class.align-center]="subjectTaxonomyTags().includes(TAXONOMY.CENTERED)">
          {{ title }}
        </h2>
      }
      @if (text(); as text) {
        <div class="pr-medium-b" [innerHTML]="text | finSafe: 'html'"></div>
      }

      <div class="discover-now-area">
        @for (item of items; track item.contentId) {
          <div class="discover-now-item pr-medium-r">
            <!-- FIXME: add icons once CMS return them -->
            <div class="discover-now-image">
              @if (item?.media?.length) {
                <fin-content-image class="block mr-medium-b br-large" [imageData$]="item.media[0] | finToObservable" />
              }
            </div>
            <h3 class="nordic-blue-900-text text-icon-primary" [class.mr-clear-t]="item?.media?.length">
              {{ item.teaserTitle }}
            </h3>
            <div [innerHTML]="item.teaserText | finSafe: 'html'" class="discover-now-teaser-text"></div>
            <div class="discover-now-links">
              @for (related of item.related; track related?.target?.url) {
                @if (isNewBrand()) {
                  <fcom-link
                    class="block pr-xxsmall-t"
                    [href]="related?.target?.url"
                    [external]="related?.target?.external"
                    [openInNewTab]="related?.target?.openInNewTab"
                    [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
                    >{{ related?.teaserTitle }}</fcom-link
                  >
                } @else {
                  <a
                    [finLink]="related?.target?.url"
                    [external]="related?.target?.external"
                    [attr.target]="related?.target?.openInNewTab ? '_blank' : null"
                    class="flex flex--middle nordic-blue-900-text text-icon-primary bold-type no-underline pr-xxsmall-t font-body-1 underline-hover font-body-medium-bold"
                  >
                    <span class="title">{{ related?.teaserTitle }}</span>
                    <span class="cta">
                      <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
                    </span>
                  </a>
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
}
